<template>
  <section class="policy-container">
    <h1>🛡️ aylavblog.com Çocuk Güvenliği Standartları Politikası</h1>

    <p>
      aylavblog.com, Google’ın Çocuk Güvenliği Standartları politikasını temel alarak dijital alanda çocukların güvenliğini öncelik olarak kabul eder. Bu doğrultuda, hem içerik üretimi hem de kullanıcı etkileşimleri bakımından aşağıdaki ilkeleri benimsemekteyiz:
    </p>

    <div class="section" v-for="(item, index) in policyItems" :key="index">
      <h2>{{ index + 1 }}. {{ item.title }}</h2>
      <div v-html="item.content"></div>
    </div>

    <p>
      aylavblog.com olarak, dijital dünyanın herkes için daha güvenli bir yer olması için çalışıyor, özellikle çocukların korunmasına öncelik veriyoruz.
    </p>
  </section>
</template>

<script>
export default {
  name: 'ChildSafetyPolicy',
  data() {
    return {
      policyItems: [
        {
          title: 'Genel Yaklaşım',
          content: `
            <p>Google Play’in Çocuk Güvenliği Standartları ile uyumlu olarak, aylavblog.com çocukların dijital ortamda güvenli bir deneyim yaşamasını hedefler. Topluluğumuzda çocuklara yönelik her türlü istismar, zararlı davranış ve uygunsuz içerik açıkça yasaktır.</p>
          `,
        },
        {
          title: 'Yayın Standartlarımız',
          content: `
            <p>Site genelindeki içerik politikalarında çocuklara yönelik her türlü cinsel istismar ve istismarı (CSAE) kesin şekilde yasaklanmıştır.</p>
            <p><strong>Örnek uygulama:</strong><br>“aylavblog.com üzerinde, çocuklarla uygunsuz iletişim ya da onları istismar edebilecek herhangi bir içerik kesinlikle kabul edilmez.”</p>
          `,
        },
        {
          title: 'Kullanıcı Geri Bildirimi',
          content: `
            <p>Her sayfada yer alan iletişim bölümü aracılığıyla kullanıcılar uygunsuz buldukları içerikleri bize iletebilir. Çocuk güvenliğiyle ilgili bildirilen içerikler, editör ekibimiz tarafından öncelikli olarak incelenir.</p>
          `,
        },
        {
          title: 'CSAM ile Mücadele',
          content: `
            <p>Herhangi bir şekilde Çocuk Cinsel İstismar Materyali (CSAM) tespit edilirse, içerik derhal yayından kaldırılır ve gerekirse ilgili kurumlara bildirim yapılır. Bu kapsamda yerel yasalar ve Google’ın raporlama prosedürleri dikkate alınır.</p>
          `,
        },
        {
          title: 'Yasal Uyum',
          content: `
            <p>aylavblog.com, Türkiye’de ve hizmet verdiği tüm bölgelerde çocuk koruma yasalarına uyar. CSAE/CSAM ile ilgili durumlarda NCMEC (National Center for Missing & Exploited Children) ya da ilgili resmi kurumlara bildirim yapılabilir.</p>
          `,
        },
        {
          title: 'Sorumlu İletişim Yetkilisi',
          content: `
            <p><strong>Yetkili Kişi:</strong> aylavblog editör ekibi<br>
            <strong>İletişim Adresi:</strong> <a href="mailto:info@aylavblog.com">info@aylavblog.com</a><br>
            Bu ekip, çocuk güvenliğiyle ilgili Google’dan ya da kullanıcılarımızdan gelen bildirimleri değerlendirir.</p>
          `,
        },
        {
          title: 'Politika İhlali ve Yaptırımlar',
          content: `
            <p>Herhangi bir CSAE/CSAM içeriği tespit edildiğinde:</p>
            <ul>
              <li>İlgili içerik anında kaldırılır</li>
              <li>Paylaşımı yapan hesap (varsa) engellenir</li>
              <li>Yasal işlem süreci başlatılır</li>
            </ul>
          `,
        },
        {
          title: 'Bildirim ve Acil Durum',
          content: `
            <p>Aşağıdaki e-posta adresinden bizimle iletişime geçebilirsiniz:<br>
            <a href="mailto:info@aylavblog.com">info@aylavblog.com</a></p>
            <p>Acil bir durum varsa yerel güvenlik birimlerine başvurmanız önerilir.</p>
          `,
        }
      ]
    };
  },
  mounted() {
    // Gerekirse bileşen yüklendiğinde yapılacak işlemler buraya eklenebilir.
    console.log('ChildSafetyPolicy component mounted');
  }
};
</script>

<style scoped>
.policy-container {
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  line-height: 1.7;
  color: #333;
  background-color: #fff;
  border-radius: 8px;
}

.section {
  margin-bottom: 2rem;
}

h1 {
  font-size: 1.8rem;
  margin-bottom: 1.2rem;
}

h2 {
  font-size: 1.3rem;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  color: #2a2a2a;
}

a {
  color: #007BFF;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}

ul {
  padding-left: 1.5rem;
}
</style>
